import React from "react";
import { FaFacebook, FaPinterest, FaEnvelope, FaTwitter } from "react-icons/fa";
export var AddThis = function AddThis(_ref) {
  var _ref$fa = _ref.fa,
      fa = _ref$fa === void 0 ? {} : _ref$fa,
      _ref$tw = _ref.tw,
      tw = _ref$tw === void 0 ? {} : _ref$tw,
      _ref$pin = _ref.pin,
      pin = _ref$pin === void 0 ? {} : _ref$pin,
      _ref$email = _ref.email,
      email = _ref$email === void 0 ? {} : _ref$email;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    class: "addthis_inline_share_toolbox "
  }));
};